import { render, staticRenderFns } from "./ChangeStatusMassively.vue?vue&type=template&id=6168fe7e&scoped=true"
import script from "./ChangeStatusMassively.vue?vue&type=script&lang=js"
export * from "./ChangeStatusMassively.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusMassively.vue?vue&type=style&index=0&id=6168fe7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168fe7e",
  null
  
)

export default component.exports